import { createSlice } from "@reduxjs/toolkit";
import { startCall, getPendingCalls, answerCall, sendCandidates, getCandidates, getCallStatus, endCall } from "./thunk";

export interface CallsState {
  callId: string | null;
  status: string | null;
  pending: any[];
  lastCandidates: any[];
  lastTs: number;
  loading: boolean;
  error?: string | null;
}

const initialState: CallsState = {
  callId: null,
  status: null,
  pending: [],
  lastCandidates: [],
  lastTs: 0,
  loading: false,
  error: null,
};

const CallsSlice = createSlice({
  name: "Calls",
  initialState,
  reducers: {
    resetCallsState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(startCall.pending, (state) => {
        state.loading = true;
      })
      .addCase(startCall.fulfilled, (state: any, action: any) => {
        state.loading = false;
        if (action.payload?.status) {
          state.callId = action.payload.data?.callId || null;
          state.status = "ringing";
        }
      })
      .addCase(startCall.rejected, (state: any, action: any) => {
        state.loading = false;
        state.error = action.payload || action.error?.message || "Failed to start call";
      })

      .addCase(getPendingCalls.fulfilled, (state: any, action: any) => {
        if (action.payload?.status) {
          state.pending = action.payload.data || [];
        }
      })

      .addCase(answerCall.fulfilled, (state: any, action: any) => {
        if (action.payload?.status) {
          state.status = "connected";
        }
      })

      .addCase(sendCandidates.fulfilled, (state: any) => {})

      .addCase(getCandidates.fulfilled, (state: any, action: any) => {
        if (action.payload?.status) {
          state.lastCandidates = action.payload.data?.candidates || [];
          state.lastTs = action.payload.data?.ts || state.lastTs;
        }
      })

      .addCase(getCallStatus.fulfilled, (state: any, action: any) => {
        if (action.payload?.status) {
          state.status = action.payload.data?.status || state.status;
        }
      })

      .addCase(endCall.fulfilled, (state: any, action: any) => {
        if (action.payload?.status) {
          state.callId = null;
          state.status = "ended";
        }
      });
  },
});

export const { resetCallsState } = CallsSlice.actions;
export default CallsSlice.reducer;


